function setupBeacon() {
  if (typeof Beacon === 'undefined') {
    return
  }

  // Prevent Beacon from displaying it’s own bubble.
  Beacon('config', {
    display: {
      style: 'manual',
      position: 'right',
    },
  })

  // Note:
  // Beacon('identify', {...}) is called from layouts/shared/_beacon.html.erb
  // to pass the user’s name and email address to Beacon.

  // Initialize Beacon
  Beacon('init', 'b894bb83-fe54-490b-988b-cacb0bc98a23')

  // Launch Beacon when the user clicks the support link.
  const supportLink = document.querySelector('.nav_link--support')
  supportLink.addEventListener('click', event => {
    event.preventDefault()
    Beacon('toggle')
  })
}

document.addEventListener('turbolinks:load', setupBeacon)
